
export const utilityServices = [
  {
    id: 1,
    name: 'Electric Utility',
    icon: 'ri-flashlight-line',
    description: 'Roseville Electric provides reliable, affordable electricity to over 56,000 residential and commercial customers.',
    phone: '(916) 774-5300',
    email: 'electric@roseville.ca.us',
    hours: 'Mon-Fri: 8:00 AM - 5:00 PM',
    features: ['Online Bill Pay', 'Outage Reporting', 'Energy Rebates', 'Solar Programs'],
    rates: 'Starting at $0.12/kWh',
    color: 'amber'
  },
  {
    id: 2,
    name: 'Water Utility',
    icon: 'ri-drop-line',
    description: 'Clean, safe drinking water delivered to homes and businesses throughout Roseville from local reservoirs and treatment facilities.',
    phone: '(916) 774-5750',
    email: 'water@roseville.ca.us',
    hours: 'Mon-Fri: 8:00 AM - 5:00 PM',
    features: ['Water Quality Reports', 'Conservation Programs', 'Leak Detection', 'New Service Setup'],
    rates: 'Starting at $35.50/month',
    color: 'sky'
  },
  {
    id: 3,
    name: 'Wastewater Services',
    icon: 'ri-recycle-line',
    description: 'Comprehensive wastewater collection and treatment services protecting public health and the environment.',
    phone: '(916) 774-5750',
    email: 'wastewater@roseville.ca.us',
    hours: 'Mon-Fri: 8:00 AM - 5:00 PM',
    features: ['Sewer Maintenance', 'Grease Disposal', 'Industrial Permits', 'Emergency Response'],
    rates: 'Included with water service',
    color: 'emerald'
  },
  {
    id: 4,
    name: 'Solid Waste & Recycling',
    icon: 'ri-delete-bin-line',
    description: 'Weekly trash collection, recycling, and green waste services for a cleaner, more sustainable Roseville.',
    phone: '(916) 774-5780',
    email: 'solidwaste@roseville.ca.us',
    hours: 'Mon-Fri: 8:00 AM - 5:00 PM',
    features: ['Curbside Pickup', 'Bulky Item Collection', 'Hazardous Waste', 'Composting Programs'],
    rates: 'Starting at $28.75/month',
    color: 'green'
  },
  {
    id: 5,
    name: 'Natural Gas',
    icon: 'ri-fire-line',
    description: 'PG&E provides natural gas service to Roseville residents for heating, cooking, and hot water needs.',
    phone: '1-800-743-5000',
    email: 'support@pge.com',
    hours: '24/7 Emergency Line',
    features: ['Online Account Management', 'Gas Leak Reporting', 'Appliance Rebates', 'Budget Billing'],
    rates: 'Variable rates apply',
    color: 'orange'
  },
  {
    id: 6,
    name: 'Internet & Cable',
    icon: 'ri-wifi-line',
    description: 'Multiple providers offer high-speed internet, cable TV, and phone services throughout Roseville.',
    phone: 'Various Providers',
    email: 'Contact provider directly',
    hours: 'Varies by provider',
    features: ['Fiber Optic Available', 'Bundle Packages', 'Business Services', 'Streaming Options'],
    rates: 'Starting at $49.99/month',
    color: 'violet'
  }
];

export const quickLinks = [
  { name: 'Pay Your Bill Online', icon: 'ri-bank-card-line', url: '#pay-bill' },
  { name: 'Report an Outage', icon: 'ri-alarm-warning-line', url: '#report-outage' },
  { name: 'Start/Stop Service', icon: 'ri-play-circle-line', url: '#start-stop' },
  { name: 'Conservation Tips', icon: 'ri-leaf-line', url: '#conservation' },
  { name: 'Rebates & Incentives', icon: 'ri-gift-line', url: '#rebates' },
  { name: 'Contact Support', icon: 'ri-customer-service-line', url: '#contact' }
];

export const conservationPrograms = [
  {
    id: 1,
    title: 'Smart Thermostat Rebate',
    description: 'Get up to $75 back when you purchase a qualifying smart thermostat.',
    savings: 'Save up to 15% on heating/cooling',
    icon: 'ri-temp-cold-line'
  },
  {
    id: 2,
    title: 'Water-Wise Landscaping',
    description: 'Rebates for replacing grass with drought-tolerant plants and efficient irrigation.',
    savings: 'Up to $1,000 rebate available',
    icon: 'ri-plant-line'
  },
  {
    id: 3,
    title: 'Solar Panel Program',
    description: 'Net metering and incentives for residential solar installation.',
    savings: 'Reduce electric bills by 50-90%',
    icon: 'ri-sun-line'
  },
  {
    id: 4,
    title: 'High-Efficiency Appliances',
    description: 'Rebates on ENERGY STAR washers, dryers, and refrigerators.',
    savings: 'Up to $200 per appliance',
    icon: 'ri-fridge-line'
  }
];

export const utilityStats = [
  { label: 'Customers Served', value: '56,000+', icon: 'ri-home-4-line' },
  { label: 'Reliability Rate', value: '99.9%', icon: 'ri-shield-check-line' },
  { label: 'Water Quality Score', value: 'A+', icon: 'ri-drop-line' },
  { label: 'Renewable Energy', value: '50%', icon: 'ri-leaf-line' }
];
